import i18nInst from "i18next";

import { SupportedLanguage } from "../models";
import { Log } from "./log.helpers";

export const changeI18nLang = async (
  newLang: SupportedLanguage,
): Promise<void> => {
  if (i18nInst.language === newLang) {
    return;
  }

  const switchLang = i18nInst
    .changeLanguage(newLang)
    .then(() => {
      document.dir = i18nInst.dir();
    })
    .catch(e => {
      Log.warnAndToast(`Error switching translation language to ${newLang}`, e);
    });
  return switchLang;
};
